/**
 * @generated SignedSource<<98a2a8fd95705432a07245c6430b406a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type contentLiveArticleArticle$data = {
  readonly " $fragmentSpreads": FragmentRefs<"itemLiveArticleContentArticle">;
  readonly " $fragmentType": "contentLiveArticleArticle";
};
export type contentLiveArticleArticle$key = {
  readonly " $data"?: contentLiveArticleArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"contentLiveArticleArticle">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "contentLiveArticleArticle",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "itemLiveArticleContentArticle"
    }
  ],
  "type": "Article",
  "abstractKey": null
};

(node as any).hash = "d8dd92ce99a96c4a891da6007f136748";

export default node;
